<script setup lang="ts">
import { toFieldValidator } from '@vee-validate/zod'
import { useField } from 'vee-validate'
import { ZodSchema } from 'zod'

interface RadioOption {
  id: string
  value: string
  label: string
  checked: false
}

const props = withDefaults(
  defineProps<{
    modelValue: string
    label: string
    name: string
    items: RadioOption[]
    validation?: ZodSchema
  }>(),
  {},
)

const { value, errorMessage, setValue } = useField<string>(
  props.name,
  props.validation ? toFieldValidator(props.validation) : undefined,
)
const onChange = (v?: string) => setValue(v || '')
</script>

<template>
  <div>
    <h4 class="text-normal text-semibold mb-4 mt-4 text-[#6B7280]">
      {{ label }}
    </h4>

    <RadioButton
      v-for="item in items"
      :model-value="value"
      @change="onChange"
      :key="item.id"
      :value="item.value"
      :name="name"
      :label="item.label"
      :id="item.id"
    />

    {{ errorMessage }}
  </div>
</template>
